export enum BreadcrumbType {
	Startpage = 0,
	Category = 1,
	Az = 2,
	Catalog = 3,
	Search = 4,
	Preview = 5,
	InternationalCatalogs = 6
}
